import React from 'react';
import './Emergency.scss';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import EmergencyImg from '../../assets/emergency.png';
import { Link } from 'react-router-dom';

const Emergency = () => {
    return (
        <section className='emergency-section' 
                 data-aos="fade-up" 
                 data-aos-duration="2000"
                 aria-labelledby="emergency-heading">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-6">
                        <div className="emergency-img">
                            <img src={EmergencyImg} alt="Emergency dental care in Ottery, Cape Town" />
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                        <div className="emergency-text">
                            <SectionTitle 
                                subTitle="Dental 24H Emergency in Ottery, Cape Town" 
                                title="Gentle, friendly emergency treatment from our local practice." 
                                description="Dental emergencies don't wait—and neither should you. Whether it's sudden tooth pain, a chipped tooth, or swelling, Dr. Mishqah Dollie offers compassionate, efficient emergency care in Ottery, Cape Town when you need it most. Our goal is to relieve your discomfort quickly and restore your oral health with care you can trust. Available for urgent dental care in the Southern Suburbs area."
                            />

                            <div className="button-group">
                                <div className="theme-btn">
                                    <a href="https://www.recomed.co.za/dentist/cape-town/mishqah-dollie/7579/7349/" 
                                       target="_blank" 
                                       rel="noopener noreferrer"
                                       aria-label="Book an emergency dental appointment with Dr Mishqah Dollie in Ottery, Cape Town">
                                        Book an appointment
                                    </a>
                                </div>
                                <div className="theme-btn readmore-btn">
                                    <Link to="/about" aria-label="Learn more about Dr Mishqah Dollie's dental practice">
                                        Read More
                                    </Link>
                                </div>
                            </div>
                            
                            <div className="emergency-contact" role="complementary" aria-label="Emergency contact information">
                                <p><strong>Emergency Contact:</strong> <a href="tel:+27649144852" aria-label="Call emergency number 064 914 4852">064 914 4852</a></p>
                                <p><strong>Location:</strong> 280 Ottery Road, Southern Suburbs, Ottery, Cape Town</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Emergency;